import { DeviceSettings } from "@/components/Elemnt/DeviceSettings";
import { useParams } from "react-router";

const DeviceConfigPage = () => {
  const { appToken = "" } = useParams();
  return <DeviceSettings appToken={appToken} />;
};

export default DeviceConfigPage;
